// Fixed grain overlay for the editorial print texture.
export const Noise = () => <div className="grain" aria-hidden="true" />;
